import styled, { css } from 'styled-components';
import { media } from 'src/components/base';

export const Advert = styled.li<{
  row: number;
  $display: string;
}>(
  p => css`
    list-style: none;
    grid-row: ${p.row || '0'};
    grid-column: 1 / -1;

    ${p.$display === 'mobile' &&
    css`
      ${media.mediumUp` display:none; `}
    `};

    ${p.$display === 'desktop' &&
    css`
      ${media.smallOnly` display:none; `}
    `};
  `
);
